module.exports = __webpack_public_path__ + "static/media/tw.295251bb.svg";